var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"click":_setup.focus}},[(_setup.editor)?_c(_setup.EditorToolbar,{attrs:{"editor":_setup.editor}}):_vm._e(),(_setup.editor)?_c(_setup.EditorContent,{staticClass:"rich-text",attrs:{"placeholder":_vm.placeholder,"editor":_setup.editor}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }